import { ViewModel,View, ObservableArray } from "binder"
import { CallServerViewModel } from "../executablePart/callServer/callServer-viewModel";
import { CreateInstanceViewModel } from "../executablePart/createInstance/createInstance-viewModel";
import { CreatePaginationInfoViewModel } from "../executablePart/createPaginationInfo/createPaginationInfo-viewModel";
import { IExecutablePart, IExecutablePartVisitor } from "../executablePart/executablePart";
import { JsCodeViewModel } from "../executablePart/jsCode/jsCode-viewModel";
import { ShowPopupViewModel } from "../executablePart/showPopup/showPopup-viewModel";
import  { ExecutableView } from "./executable-view"
import { PreAfterAdderViewModel } from "./preAfterAdder/preAfterAdder-viewModel";

export class ExecutableViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.executableParts = ObservableArray.create<PreAfterAdderViewModel>();
        this.addExecutablePart(new JsCodeViewModel(this));
    }
    GetDefaultView(): View <ViewModel> {
        return new ExecutableView();
    }
    public getTypeId(): string {
        return "VM-BDE6C76D-C506-40D6-BA1B-2BA5C2520531"
    }

    public set executableParts(v: ObservableArray<PreAfterAdderViewModel>) { this._executableParts = v; } public get executableParts(): ObservableArray<PreAfterAdderViewModel> { return this._executableParts;} private _executableParts: ObservableArray<PreAfterAdderViewModel>;

    decorate(executablePart:IExecutablePart):PreAfterAdderViewModel{
        let decorator = new PreAfterAdderViewModel(this);
        decorator.part = executablePart;
        return decorator;
    }

    addExecutablePart(executablePart : IExecutablePart){
        this.executableParts.push(this.decorate(executablePart));
    }
    addAfter(newOne:IExecutablePart,pivot:PreAfterAdderViewModel){
        let index = this.executableParts.indexOf(pivot);
        this.executableParts.insertAt(index+1,this.decorate(newOne));
    }
    addBefore(newOne:IExecutablePart,pivot:PreAfterAdderViewModel){
        let index = this.executableParts.indexOf(pivot);
        this.executableParts.insertAt(index,this.decorate(newOne));
        
    }
    removeExecutablePart(executablePart : PreAfterAdderViewModel){
        if(this.executableParts.length==1)
            return;
        this.executableParts.remove(executablePart);
    }

    serialize():any{
        return new ExecutablePartSerializer().serialize(this.executableParts.map(x=>x.part));
    }
    deserialize(code:any){
        let parts = new ExecutablePartDeserializer().deserialize(this,code);
        this.executableParts.update(...parts.map(x=>this.decorate(x)))
    }

}

class ExecutablePartSerializer implements IExecutablePartVisitor{
    serialize(parts:IExecutablePart[]){
        return parts.map(x=>x.accept(this,null));
    }
    
    VisitJsCode(code: JsCodeViewModel, parameter: any): any {
        return {
            Type:'JsCode',
            Code : code.code
        }
    }

    VisitCreateInstance(arg0: CreateInstanceViewModel, parameter: any): unknown {
        return {
            Type:'CreateInstance',
            InstanceType : arg0.getTypeName(),
            VariableName : arg0.variableName
        }
    }
    VisitCallServer(arg0: CallServerViewModel, parameter: any) {
        return {
            Type:'CallServer',
            Address : arg0.address,
            InitializationCode : arg0.initializationCode.serialize(),
            SettingCode : arg0.settingCode.serialize(),
            InVariableName : arg0.inVariableName,
            OutVariableName : arg0.outVariableName,
        }
    }
    VisitShowPopup(arg0: ShowPopupViewModel, parameter: any): any {
        return {
            Type:'ShowPopup',
            VariableName :arg0.VariableName,
            Template : arg0.templateSelector.getValue(),
            PopupHeight : arg0.popupHeight,
            PopupWidth : arg0.popupWidth,
            WaitUntilFinish : arg0.waitUntilFinish,
            ReturnVariableName : arg0.returnVariableName
        }
    }
    VisitCreatePaginationInfo(arg0: CreatePaginationInfoViewModel, parameter: any): unknown {
        return {
            Type:'CreatePaginationInfo',
            VariableName :arg0.resultName,
            IsStatic : arg0.isStatic,
            CurrentPage : arg0.currentPage,
            Total : arg0.totalPages
        }
    }
    
}

class ExecutablePartDeserializer implements IExecutablePartVisitor {
    
    deserialize(parent:ViewModel,code:any):IExecutablePart[]{
        return code.map(x=>{
            let result = this.deserializeSinglePart(x,parent);
            return result;
        })
    }

    deserializeSinglePart(part:any,parent:ViewModel){
        let type = this.createBase(parent,part.Type);
        type.accept(this,part);
        return type;
    }

    VisitJsCode(arg0: JsCodeViewModel, part: any) {
        arg0.code = part.Code;
    }
    VisitCreateInstance(arg0: CreateInstanceViewModel, part: any): any {
        arg0.setTypeName(part.InstanceType);
        arg0.variableName = part.VariableName;
    }

    VisitCallServer(arg0: CallServerViewModel, part: any) {
        arg0.address = part.Address;
        arg0.initializationCode.deserialize(part.InitializationCode);
        arg0.settingCode.deserialize(part.SettingCode);
        arg0.inVariableName = part.InVariableName;
        arg0.outVariableName = part.OutVariableName;
    }
    VisitShowPopup(arg0: ShowPopupViewModel, part: any) {
        arg0.VariableName = part.VariableName;
        arg0.popupHeight = part.PopupHeight; 
        arg0.popupWidth = part.PopupWidth;
        arg0.templateSelector.setValue(part.Template);
        arg0.waitUntilFinish = part.WaitUntilFinish;
        arg0.returnVariableName = part.ReturnVariableName;
    }
    VisitCreatePaginationInfo(arg0: CreatePaginationInfoViewModel, part: any): any {
        arg0.resultName = part.VariableName;
        arg0.isStatic = part.IsStatic;
        arg0.currentPage = part.CurrentPage;
        arg0.totalPages = part.Total;
    }
    
    createBase(parent:ViewModel, type:string) : IExecutablePart{
        switch(type){
            case "JsCode":
                return new JsCodeViewModel(parent);
            case "CallServer":
                return new CallServerViewModel(parent);
            case "CreateInstance":
                return new CreateInstanceViewModel(parent);
            case "ShowPopup":
                return new ShowPopupViewModel(parent);
            case "CreatePaginationInfo":
                return new CreatePaginationInfoViewModel(parent);
        }
        return null;
    }
}
